import React, { useEffect, useState } from "react";
import { Modal } from "@zendeskgarden/react-modals";
import { Alert } from "@zendeskgarden/react-notifications";
import { useSelector } from "redux/store";
import { checkRole } from "utils/tools";

export default function ViewTemplate({ editTemplateItem, toggleViewModal }) {
  const role = useSelector((state) => state.user.role);
  const [editData, setEditData] = useState({});
  useEffect(() => {
    setEditData(editTemplateItem);
  }, [editTemplateItem]);
  return (
    <>
      <Modal
        style={{ width: "600px" }}
        onClose={() => {
          toggleViewModal();
        }}
      >
        <Modal.Close aria-label="Close modal" />
        <Modal.Header tag="h2">Auto Reply Template - {editTemplateItem.intent_label}</Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: editTemplateItem.message }} />
        </Modal.Body>
        <Modal.Footer>
          {!checkRole(role) && (
            <Alert type="info">
              Template configuration is managed by your team admin. Please contact them for any changes.{" "}
            </Alert>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
